import {useTranslation} from 'react-i18next';
import {AddFormV2Type} from 'context/guest';
import {FORM_NAMES} from 'utils/guestForm';
import {groupByGroupName} from './utils/groupByGroupName';
import {useGuestGroup} from 'hooks';
import type {FormFieldsMapper} from './types';
import {FormFieldV2, FIELD_TYPES} from '@guestapp/sdk';
import {STANDARD_FIELD_V2_TYPES} from '@guestapp/core';
import {CustomField} from './CustomField';
import {DefaultField} from './DefaultField';
import {FieldsGroup} from 'components/FieldsGroup';

const adaptCustomType = (type: STANDARD_FIELD_V2_TYPES): FIELD_TYPES => {
  const types = Object.values(FIELD_TYPES) as string[];
  if (types.includes(type)) {
    return type as unknown as FIELD_TYPES;
  }
  return FIELD_TYPES.text;
};

const adaptCustomField = (field: FormFieldV2) => ({
  field_type: adaptCustomType(field.type),
  is_custom: true,
  is_required: field.is_required,
  name: field.name,
  names: field.name_translations ? [field.name_translations] : [],
  placeholders: field.placeholder_translations ? [field.placeholder_translations] : [],
  configuration: field.configuration,
});

type Props = {
  defaultFieldsMapper: FormFieldsMapper;
  formFields: AddFormV2Type;
  isDisabled?: boolean;
};
export const GroupedFields = ({defaultFieldsMapper, formFields, isDisabled}: Props) => {
  const {t} = useTranslation();
  const {isLeaderGuest} = useGuestGroup();
  const groups = groupByGroupName(formFields, defaultFieldsMapper, isLeaderGuest);

  return groups.map((group, index) => (
    <FieldsGroup title={group.title} key={index} withWhyDataRequired={index === 0}>
      {group.fields.map(field =>
        field.is_custom ? (
          <CustomField
            key={field.name}
            field={adaptCustomField(field)}
            disabled={isDisabled}
            required={field.is_required ? t('this_field_is_required') : false}
          />
        ) : (
          <DefaultField
            key={field.name}
            formFieldsMapper={defaultFieldsMapper}
            fieldName={field.name as FORM_NAMES}
            formFields={formFields}
          />
        ),
      )}
    </FieldsGroup>
  ));
};
